import { Maybe } from '@varo/graphql-schema-types';
import { StandardOfferCard } from 'features/rewards/components/StandardOfferCard/StandardOfferCard';
import { FlatList, ImageSourcePropType, StyleSheet, View } from 'react-native';
import { PressableAnalyticsProps } from 'shared/hooks/analytics/usePressableAnalytics';
import theme from 'shared/styles/theme';

interface StandardOfferCard extends PressableAnalyticsProps {
  id: string;
  titleText: string;
  captionText: string;
  distanceText?: string;
  isLocationBased?: boolean;
  logoImage?: ImageSourcePropType;
  isActivatedOffer?: boolean;
  activatedDurationText?: string;
  onPress?: () => void;
  ctaButtonLabel?: string;
  onCtaButtonPress?: () => void;
  ctaButtonAnalyticsId?: string;
  ctaButtonCustomAttributes?: Maybe<Record<string, unknown>>;
  ctaLinkLabel?: string;
  onCtaLinkPress?: () => void;
}

export interface StandardOfferCardCarouselProps {
  offers: StandardOfferCard[];
}

const StandardOfferCardCarousel = ({
  offers,
}: StandardOfferCardCarouselProps) => {
  return (
    <View style={styles.container}>
      <FlatList
        contentContainerStyle={styles.standardOfferCardCarousel}
        data={offers}
        renderItem={({ item }) => (
          <StandardOfferCard
            id={item.id}
            titleText={item.titleText}
            captionText={item.captionText ?? ''}
            distanceText={item.distanceText ?? ''}
            isLocationBased={item.isLocationBased ?? false}
            isActivatedOffer={item.isActivatedOffer ?? false}
            activatedDurationText={item.activatedDurationText ?? ''}
            onPress={item.onPress}
            logoImage={item.logoImage}
            analyticsId={item.analyticsId}
            customAttributes={item.customAttributes}
            cta={{
              button: item.ctaButtonLabel
                ? {
                    label: item.ctaButtonLabel,
                    onPress: item.onCtaButtonPress,
                    analyticsId: item.ctaButtonAnalyticsId,
                    customAttributes: item.ctaButtonCustomAttributes,
                  }
                : undefined,
              link: item.ctaLinkLabel
                ? {
                    label: item.ctaLinkLabel,
                    onPress: item.onCtaLinkPress,
                  }
                : undefined,
            }}
          />
        )}
        keyExtractor={(item) => item.id.toString()}
        horizontal
        showsHorizontalScrollIndicator={false}
        ItemSeparatorComponent={() => <View style={styles.separator} />}
        removeClippedSubviews={false}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: theme.spacing.m,
  },
  separator: {
    backgroundColor: 'transparent',
    width: theme.spacing.s,
  },
  standardOfferCardCarousel: {
    paddingEnd: theme.spacing.m,
    paddingStart: theme.spacing.m,
  },
});

export default StandardOfferCardCarousel;
